/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  eqeqeq,
  import/no-extraneous-dependencies,
  max-len,
  no-script-url
*/
import React from 'react';
import PropTypes from 'prop-types';
import DropDownMenu from 'common/components/drop-down-menu';
import createReactClass from 'create-react-class';
import classNames from 'classnames';
import HfReactHelper from 'common/utils/hf-react-helper';
import LogInButton from './login-button';
import SignUpButton from './signup-button';
import TopBarMenuLink from './top-bar-menu-link';
import {
  TOP_BAR_V2_EXPERIMENT_LINK_DATA,
  TOP_BAR_V2_EXPERIMENT_SCREEN_THRESHOLD,
  TOP_BAR_V2_EXPERIMENT_COOKIE_NAME,
  TOP_BAR_V2_EXPERIMENT_COOKIE_VALUE,
} from './experiments/top-bar-v2';

const TopBarMenu = createReactClass({

  propTypes: {
    topBarMenuLinkData: PropTypes.array.isRequired,
    dropDownMenuLinkData: PropTypes.array.isRequired,
    pageToHighLight: PropTypes.string,
    useWhite: PropTypes.bool,
    useBlack: PropTypes.bool,
    isCompact: PropTypes.bool,
    isLogInButtonVisible: PropTypes.bool,
    isSignUpButtonVisible: PropTypes.bool,
    googleSignInClientId: PropTypes.string,
    loginEmailAddress: PropTypes.string,
    loginTargetUrl: PropTypes.string,
    signupTargetUrl: PropTypes.string,
    useRegularLink: PropTypes.bool,
    loginHeaderText: PropTypes.string,
    recaptchaPublicKey: PropTypes.string,
    displayCaptcha: PropTypes.bool,
    hideDropDownMenu: PropTypes.bool,
    recoverPasswordForm: PropTypes.object.isRequired, // Serialized sfForm
    loginForm: PropTypes.object.isRequired, // Serialized sfForm
    signupForm: PropTypes.object.isRequired, // Serialized sfForm
  },

  getInitialState() {
    return {
      menuOpen: false,
    };
  },

  toggleMenu() {
    this.setState({
      menuOpen: !this.state.menuOpen,
    });
  },

  componentDidMount() {
    const container = $('.google-collapse');
    $(document).click((e) => {
      if (container.html() != $(e.target).parent().parent().html()) {
        if (this.state.menuOpen) {
          this.setState({
            menuOpen: false,
          });
        }
      }
    });
  },

  openMenu() {
    this.setState({
      menuOpen: true,
    });
  },

  setStateMousedOverDropDownMenuTrue() {
    this.setState({
      mousedOverDropDownMenu: true,
    });
  },

  setStateMousedOverDropDownMenuFalse() {
    this.setState({
      mousedOverDropDownMenu: false,
    });
  },

  closeMenu() {
    const self = this;
    window.setTimeout(() => {
      if (self.state.mousedOverDropDownMenu !== true) {
        self.setState({
          menuOpen: false,
        });
      }
    }, 200);
  },

  shouldRenderV2experiement() {
    // Use v2 for desktop, and v1 for devices with view widths lower than threshold
    return (window.innerWidth >= TOP_BAR_V2_EXPERIMENT_SCREEN_THRESHOLD);
  },

  render() {

    const topBarMenuLinkDataSource = this.props.topBarMenuLinkData;

    if (this.shouldRenderV2experiement()) {
      Cookie.set(TOP_BAR_V2_EXPERIMENT_COOKIE_NAME, TOP_BAR_V2_EXPERIMENT_COOKIE_VALUE);
      return this.renderV2();
    }

    const cx = classNames;
    const linkClasses = {
      'm-link-list--link': true,
      'menu-link': true,
      'google-collapse': true,
      'c-white': !!this.props.useWhite,
      'c-ashen': !this.props.useWhite,
      'hc-cerulean': !this.props.useWhite,
      'hc-warm-chinchilla': !!this.props.useWhite,
      'show-for-medium-up': true,
    };

    const mobileMenuIconClasses = {
      'm-link-list--menu-link-mobile-icon': true,
      'c-white': !!this.props.useWhite,
      'c-ashen': !this.props.useWhite,
    };

    const topBarMenuLinks = topBarMenuLinkDataSource.map((topBarMenuLink, i) => {
      return (
        <TopBarMenuLink
          key={i}
          componentName={topBarMenuLink.componentName ? topBarMenuLink.componentName : ''}
          linkOptions={topBarMenuLink.options}
          linkOverrideColors={topBarMenuLink.linkOverrideColors}
          useWhite={this.props.useWhite}
          linkText={topBarMenuLink.text}
          linkUrl={topBarMenuLink.url}
          pageToHighLight={this.props.pageToHighLight ? this.props.pageToHighLight : ''} />
      );
    });

    let menuIfOpen;
    if (this.state.menuOpen) {
      menuIfOpen = (
        <DropDownMenu
          style={{ right: 40 }}
          dropDownMenuLinkData={this.props.dropDownMenuLinkData} />
      );
    }

    const menu = (
      <div className={`m-link-list--link--container menu-container ${this.props.hideDropDownMenu ? 'is-hidden-on-large' : ''}`} onMouseEnter={this.openMenu} onMouseLeave={this.closeMenu}>
        <a href='javascript:;' className={cx(linkClasses)} onClick={this.toggleMenu} tabIndex='-1'>
          <span>
                        MENU
            <span className='m-link-list--menu-arrow'>&#x25BE;</span>
          </span>
        </a>
        <div onMouseEnter={this.setStateMousedOverDropDownMenuTrue} onMouseLeave={this.setStateMousedOverDropDownMenuFalse}>
          { menuIfOpen }
        </div>
      </div>
    );

    let signUpButton;
    if (this.props.isSignUpButtonVisible && this.props.googleSignInClientId) {
      signUpButton = (
        <SignUpButton
          googleSignInClientId={this.props.googleSignInClientId}
          useWhite={this.props.useWhite}
          useBlack={this.props.useBlack}
          isCompact={this.props.isCompact}
          signupForm={this.props.signupForm}
          loginForm={this.props.loginForm}
          recoverPasswordForm={this.props.recoverPasswordForm}
          async={false} />
      );
    }
    if (this.props.isSignUpButtonVisible && this.props.googleSignInClientId) {
      signUpButton = (
        <SignUpButton
          googleSignInClientId={this.props.googleSignInClientId}
          useWhite={this.props.useWhite}
          useBlack={this.props.useBlack}
          isCompact={this.props.isCompact}
          signupUrl={this.props.signupTargetUrl}
          useRegularLink={this.props.useRegularLink}
          loginForm={this.props.loginForm}
          recoverPasswordForm={this.props.recoverPasswordForm}
          signupForm={this.props.signupForm}
          async={false} />
      );
    }

    let logInButton;
    if (this.props.isLogInButtonVisible && this.props.googleSignInClientId) {
      logInButton = (
        <LogInButton
          recaptchaPublicKey={this.props.recaptchaPublicKey}
          emailAddress={this.props.loginEmailAddress}
          googleSignInClientId={this.props.googleSignInClientId}
          useWhite={this.props.useWhite}
          useBlack={this.props.useBlack}
          isCompact={this.props.isCompact || this.props.hideDropDownMenu}
          recoverPasswordForm={this.props.recoverPasswordForm}
          loginForm={this.props.loginForm}
        ></LogInButton>
      );
    }
    if (this.props.isLogInButtonVisible && this.props.googleSignInClientId) {
      logInButton = (
        <LogInButton
          emailAddress={this.props.loginEmailAddress}
          googleSignInClientId={this.props.googleSignInClientId}
          useWhite={this.props.useWhite}
          useBlack={this.props.useBlack}
          isCompact={this.props.isCompact || this.props.hideDropDownMenu}
          loginUrl={this.props.loginTargetUrl}
          headerText={this.props.loginHeaderText}
          recaptchaPublicKey={this.props.recaptchaPublicKey}
          displayCaptcha={this.props.displayCaptcha}
          useRegularLink={this.props.useRegularLink}
          recoverPasswordForm={this.props.recoverPasswordForm}
          loginForm={this.props.loginForm} />
      );
    }

    return (
      <div className={`m-link-list small-9 columns text-center ${(!this.props.isLogInButtonVisible && !this.props.isSignUpButtonVisible && this.props.hideDropDownMenu) ? 'is-compact' : ''}`} data-equalizer-watch>
        { menu }
        <a href='javascript:;' className={`toggle-nav m-link-list--menu-link-mobile${this.props.useWhite ? ' c-white hc-warm-chinchilla' : ' c-castle-rock hc-cerulean'}`} tabIndex='-1'>
          <span className={cx(mobileMenuIconClasses)}></span>
        </a>
        { logInButton }
        { signUpButton }
        { topBarMenuLinks }
      </div>
    );
  },

  renderV2() {
    const topBarMenuLinkDataSource = TOP_BAR_V2_EXPERIMENT_LINK_DATA;
    const hfPricingUrl = HfReactHelper.urlHelper('info/pricing', HfReactHelper.HfSites.SITE_CODE_HF);

    const topBarMenuLinks = topBarMenuLinkDataSource.map((topBarMenuLink, i) => {
      const items = topBarMenuLink.options.sub_menu_items.map((item) => {
        if (item.url.includes('%HF_PRICING_URL%')) {
          item.url = item.url.replace('%HF_PRICING_URL%', hfPricingUrl);
        }

        return item;
      });

      topBarMenuLink.options.sub_menu_items = items;

      return (
        <TopBarMenuLink
          key={i}
          componentName={topBarMenuLink.componentName ? topBarMenuLink.componentName : ''}
          linkOptions={topBarMenuLink.options}
          linkOverrideColors={topBarMenuLink.linkOverrideColors}
          useWhite={this.props.useWhite}
          linkText={topBarMenuLink.text}
          linkUrl={topBarMenuLink.url}
          pageToHighLight={this.props.pageToHighLight ? this.props.pageToHighLight : ''} />
      );
    });

    let signUpButton;
    if (this.props.isSignUpButtonVisible && this.props.googleSignInClientId) {
      signUpButton = (
        <SignUpButton
          googleSignInClientId={this.props.googleSignInClientId}
          useWhite={this.props.useWhite}
          useBlack={this.props.useBlack}
          isCompact={this.props.isCompact}
          signupUrl={this.props.signupTargetUrl}
          useRegularLink={this.props.useRegularLink}
          signupForm={this.props.signupForm}
          buttonText='SIGN UP FREE'
          recoverPasswordForm={this.props.recoverPasswordForm}
          loginForm={this.props.loginForm}
          async={false} />
      );
    }

    let logInButton;
    if (this.props.isLogInButtonVisible && this.props.googleSignInClientId) {
      logInButton = (
        <TopBarMenuLink
          linkText="Login"
          linkOptions={{
            class: 'm-link-list--link-break-1',
            container_class: 'external-top-bar',
            sub_menu_class: 'external-top-bar',
            sub_menu_lock_to_parent: true,
            show_menu_drop_down_arrow: true,
            sub_menu_items: [
              {
                url: this.props.loginTargetUrl,
                text: 'HelloSign',
              },
              {
                url: 'https://portal.helloworks.com',
                text: 'HelloWorks',
              },
            ],
          }}
          useWhite={this.props.useWhite}
          linkUrl={this.props.loginTargetUrl} />
      );
    }

    return (
      <div className={'m-link-list small-9 large-10 columns text-center '} data-equalizer-watch>
        { logInButton }
        { signUpButton }
        { topBarMenuLinks }
      </div>
    );
  },
});


module.exports = TopBarMenu;
